import React, { useEffect, useState } from 'react'
import { getMCQPastPaperQuestion } from '../../services/subjects/pastPaperQuestion';
import { useParams } from 'react-router-dom';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';

function QuestionsPrintForPaper() {

    const { paperId } = useParams();

    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        loadQuestions();
      }, [paperId]);

    const loadQuestions = async () => {
        try {
          const response = await getMCQPastPaperQuestion(paperId);
          // console.log(response.data);
          setQuestions(response.data);
        } catch (error) {
          console.log(error);
        }
      };
      
  return (
    <div>
        <Typography variant="h5" sx={{ margin: "10px" }}>
            Questions for Paper
        </Typography>
      <TableContainer sx={{ margin: "10px" }}>
        <Table>
          <TableBody>
            {questions.map((row) => (
              <TableRow key={row.index} className="print-row">
                
                <TableCell
                // size='small' 
                style={{ width: 240 }}
                  sx={{ 
                        // width: "500px",
                        // flex : 1,
                        borderWidth: '1px',
                        borderColor: 'black',
                        borderStyle: 'dashed',
                }}>
                  {
                    <span
                      dangerouslySetInnerHTML={{
                        __html: row.question.question.questionText,
                      }}
                    ></span>
                  }
                </TableCell>
                <TableCell
                style={{ width: 30 }}
                // size='small'
                    sx={{ 
                        // width: "25px",
                        color : 'red',
                        borderWidth: '1px',
                        borderColor: 'black',
                        borderStyle: 'dashed',

                    }}
                >
                {" "}
                </TableCell>
                <TableCell
                //  size='25px' 
                style={{ width: 2 }}
                 sx={{ 
                        // width: "25px",
                        borderWidth: '1px',
                        borderColor: 'black',
                        borderStyle: 'dashed',
                }}>
                    {row.id}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default QuestionsPrintForPaper